















































































import timeStepSelector from "@/components/timeStepSelector.vue";
import { rollCallEdit, rollCallEditData } from "@/api/rollCallRecord";
import stepTimeRangeSelector from "@/components/stepTimeRangeSelector.vue";
import { dateFormat } from "@/utils/timeFormat";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  name: "dialogCombox",
  components: {
    timeStepSelector,
    stepTimeRangeSelector,
  },
})
export default class extends Vue {
  @Prop() type!: any;
  @Prop() id!: number;
  @Prop() itemData!: any;
  @Prop() student_ids!: any;
  tableData = [];
  consumeClass = "";
  page = 1;
  pageSize = 10;
  pageSizeArray = [5, 10, 30, 50, 100];
  total = 5;
  dialogVisible = false;
  suspensionBtn = false;
  suspensionformIn = {
    lesson_date: "",
    lesson_start_time: "12:00",
    expire_end_time: "13:00",
    time_suspen: "",
    consume_number: "",
    consume_class: "",
  }; //停课表单
  rules = {
    lesson_date: [
      { required: true, message: "请选择上课日期", trigger: "blur" },
    ],
    time_suspen: [
      { required: true, message: "请选择上课时间", trigger: "blur" },
    ],
    consume_number: [
      { required: true, message: "请输入排课课时", trigger: "change" },
    ],
  };
  pickerOptions = {
    format: "HH:mm:ss",
  };
  consume_number = "";
  created() {
    const _t = this as any;
    switch (_t.type) {
      //如果是这个type是跟进计划的 data是一堆数据，其他的data是一个id
      case "edit":
        _t.id = Number(_t.id);
        _t.suspensionBtn = true;
        const data = { ..._t.itemData };
        _t.suspensionformIn.lesson_date = data.lesson_date;
        _t.suspensionformIn.expire_start_time = data.lesson_start_time.substr(
          0,
          5
        );
        _t.suspensionformIn.expire_end_time = data.lesson_end_time.substr(0, 5);
        _t.suspensionformIn.time_suspen = data.lesson_start_time;
        _t.suspensionformIn.consume_number = data.consume_number;
        _t.suspensionformIn.consume_class = data.consume_class;
        break;
    }
  }
  selectInit(row: any, index: any) {
    if (row.checkbox) {
      return false; //不可勾选
    } else {
      return true; //可勾选
    }
  }
  handleCourseChange(e: any, item: any) {
    const _t = this as any;
    _t.tableData[_t.tableData.indexOf(item)].course_list.map((a: any) => {
      if (e == a.course_id) {
        _t.tableData[_t.tableData.indexOf(item)].usable_number =
          a.account.usable_number;
      }
    });
  }
  handleExpectedEnd() {
    const _t = this as any;
  }
  datechoose(e: any) {
    const _t = this as any;
    let expire_start_time: number | String = "";
    let expire_end_time: number | String = "";
    if (e != null) {
      expire_start_time = dateFormat("HH:MM:SS", e[0]);
      expire_end_time = dateFormat("HH:MM:SS", e[1]);
    }
    _t.suspensionformIn.expire_start_time = expire_start_time;
    _t.suspensionformIn.expire_end_time = expire_end_time;
  }
  resumeclickClose() {
    const _t = this as any;
    _t.dialogVisible = false;
    _t.suspensionBtn = false;
    _t.$emit("goBack", _t.type);
  }
  suspensionclickComfir(data: rollCallEditData) {
    const _t = this as any;
    data.roll_call_id = _t.id;
    if (_t.suspensionformIn.expire_start_time != "") {
      data.lesson_start_time = _t.suspensionformIn.expire_start_time + ":00";
    }
    if (_t.suspensionformIn.expire_end_time != "") {
      data.lesson_end_time = _t.suspensionformIn.expire_end_time + ":00";
    }
    if (_t.suspensionformIn.lesson_date != "") {
      data.lesson_date = _t.suspensionformIn.lesson_date;
    }
    if (_t.suspensionformIn.consume_number != "") {
      data.consume_number = _t.suspensionformIn.consume_number;
    }
    if (_t.suspensionformIn.consume_class != "") {
      data.lesson_content = _t.suspensionformIn.consume_class;
    }
    const stime = _t.suspensionformIn.expire_start_time.slice(0, 5) + ":00";
    const etime = _t.suspensionformIn.expire_end_time.slice(0, 5) + ":00";
    if (Number(stime.replace(/:/g, "")) >= Number(etime.replace(/:/g, ""))) {
      this.$message({
        type: "warning",
        message: "上课结束时间必须大于开始时间",
      });
      return false;
    }
    rollCallEdit(data).then((res: any) => {
      if (res.error_code == 0) {
        _t.$message({
          type: "success",
          message: "编辑成功",
        });
        _t.resumeclickClose();
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  goBack() {
    this.$router.go(-1);
  }
}
